import { inject } from "vue";
const APP_SETTINGS_REGISTRATION_KEY = Symbol.for("NcAppSettingsDialog:registration");
function useAppSettingsDialog() {
  return inject(APP_SETTINGS_REGISTRATION_KEY);
}
export {
  APP_SETTINGS_REGISTRATION_KEY as A,
  useAppSettingsDialog as u
};
//# sourceMappingURL=useAppSettingsDialog-Dn48dw1k.mjs.map
